import React from 'react'
import { AlertTypeEnums, ContactTypeEnums, AlertSettingsItem } from '../../common/constants'
import { NotificationRow } from './NotificationRow'

interface NotificationTableProps {
  alertType: AlertTypeEnums
  settings: AlertSettingsItem[]
  onSettingChange: (alertType: AlertTypeEnums, contactType: ContactTypeEnums, itemOrder: number, setting: Partial<AlertSettingsItem>) => void
  disabled?: boolean
}

export function NotificationTable({ alertType, settings, onSettingChange, disabled }: NotificationTableProps) {
  // Find setting by contactType and itemOrder
  const findSetting = (contactType: ContactTypeEnums, itemOrder: number): AlertSettingsItem | undefined => {
    return settings.find((s) => s.contactType === contactType && s.itemOrder === itemOrder && s.alertType === alertType)
  }

  return (
    <div className="overflow-x-auto border border-gray-200 rounded-lg">
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-50">
          <tr>
            <th className="px-4 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
              Enabled
            </th>
            <th className="px-4 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
              Item
            </th>
            <th className="px-4 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
              Contact
            </th>
            <th className="px-4 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
              Custom Message
            </th>
            <th className="px-4 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
              Attempts
            </th>
            <th className="px-4 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
              Delay (min)
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {/* Email rows */}
          <NotificationRow
            setting={findSetting(ContactTypeEnums.EMAIL, 1)}
            contactType={ContactTypeEnums.EMAIL}
            itemOrder={1}
            alertType={alertType}
            onSettingChange={onSettingChange}
            disabled={disabled}
          />
          <NotificationRow
            setting={findSetting(ContactTypeEnums.EMAIL, 2)}
            contactType={ContactTypeEnums.EMAIL}
            itemOrder={2}
            alertType={alertType}
            onSettingChange={onSettingChange}
            disabled={disabled}
          />
          <NotificationRow
            setting={findSetting(ContactTypeEnums.EMAIL, 3)}
            contactType={ContactTypeEnums.EMAIL}
            itemOrder={3}
            alertType={alertType}
            onSettingChange={onSettingChange}
            disabled={disabled}
          />

          {/* SMS rows */}
          <NotificationRow
            setting={findSetting(ContactTypeEnums.SMS, 1)}
            contactType={ContactTypeEnums.SMS}
            itemOrder={1}
            alertType={alertType}
            onSettingChange={onSettingChange}
            disabled={disabled}
          />
          <NotificationRow
            setting={findSetting(ContactTypeEnums.SMS, 2)}
            contactType={ContactTypeEnums.SMS}
            itemOrder={2}
            alertType={alertType}
            onSettingChange={onSettingChange}
            disabled={disabled}
          />
          <NotificationRow
            setting={findSetting(ContactTypeEnums.SMS, 3)}
            contactType={ContactTypeEnums.SMS}
            itemOrder={3}
            alertType={alertType}
            onSettingChange={onSettingChange}
            disabled={disabled}
          />
        </tbody>
      </table>
    </div>
  )
}
